"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var null_schema_1 = __importDefault(require("./null.schema"));
exports["default"] = null_schema_1["default"];
//# sourceMappingURL=index.js.map